<template>
  <div
    class="app-image-uploader fv-form-control-group fv-padding table-responsive"
    :tabindex="0"
    :invalid="!fvValidate"
  >
    <fv-table
      v-if="filteredMedia.length"
      :rows="filteredMedia"
      :fields="tableFields"
      :title="false"
      class="table"
    >
      <template slot="field-name" slot-scope="scope">
        <div>
          <a
            class="fv-link fv-grow"
            target="_blank"
            :href="$fileManagerFile(scope.row.path)"
          >
            {{ scope.row.type }} {{ scope.index + 1 }}
          </a>
        </div>
      </template>
      <template slot="field-path" slot-scope="scope">
        <div dir="ltr" class="fv-input-group fv-flex justify-content-center">
          <b>file path:</b>
          {{ scope.row.path }}
        </div>
      </template>
      <template slot="field-alt" slot-scope="scope">
        <div dir="ltr" class="fv-input-group fv-flex">
          <button class="btn btn-info btn-sm disabled" @click.prevent>
            Alt:
          </button>
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="scope.row.alt"
            placeholder="Enter Alt"
          />
        </div>
      </template>
      <template slot="field-action" slot-scope="scope">
        <div class="d-flex">
          <button
            class="btn btn-outline-danger btn-sm"
            type="button"
            @click.prevent="deleteFile(scope.index)"
          >
            <i class="fa fa-trash" />
            Delete
          </button>
          <button
            type="button"
            class="btn btn-outline-info btn-sm mr-2"
            v-if="fields.indexOf('default') !== -1"
            @click.prevent="setDefault(scope.index)"
            :disabled="scope.row.default"
          >
            <i class="fa fa-check" />
            Set Default
          </button>
        </div>
      </template>
      <template slot="field-preview" slot-scope="scope">
        <div v-if="scope.row.path">
          <img
            v-if="scope.row.type === 'IMAGE' || scope.row.type === 'GIF'"
            :src="imageUrl + scope.row.path + '?max=50'"
          />
          <div v-else>
            {{ scope.row.type }}
          </div>
        </div>
      </template>
    </fv-table>
    <div v-if="filteredMedia.length === 0 && !uploading">No file selected</div>
    <div class="fv-padding fv-link" v-if="uploading">
      <div class="fv-vertical-padding-small">
        <i class="fa fa-spinner fa-pulse fa-fw" />
        {{ uploading }} file(s) uploading...
      </div>
      <button
        type="button"
        @click.prevent="axiosCancelExecutor()"
        class="btn btn-sm btn-danger"
      >
        Click To Cancel
      </button>
    </div>
    <div class="fv-padding">
      <input
        :id="id"
        type="file"
        ref="filepicker"
        @change="fileChange"
        :multiple="multiple"
      />
    </div>
    <div v-if="uploading" dir="ltr" class="uploadProgress">
      <div class="bar" :style="{ width: `${uploadPercent}%` }"></div>
      <div class="tip" :style="{ left: `${uploadPercent}%` }">
        {{ uploadPercent }}%
      </div>
    </div>
  </div>
</template>

<script>
// import VueCookies from 'vue-cookies'
import Vue from "vue";
import { API_URL2 } from "../env";
import axios from "axios";

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Array, Object],
      // default: () => {
      //   return []
      // }
    },
    id: {
      type: String,
    },
    fields: {
      type: Array,
      default: () => ["path", "type", "alt", "default"],
    },
    type: {
      type: Array,
      default: () => ["IMAGE", "VIDEO", "GIF", "MP3", "AMR", "MPEG"],
    },
  },
  data() {
    return {
      randomKey: Math.random() * 100,
      // imageUrl: `${API_MEDIA_URL}/`,
      pValue: undefined,
      showImages: false,
      progress: 0,
      baseUrl: API_URL2,
      uploading: 0,
      uploadPercent: 0,
      source: null,
      axiosCancelExecutor: null,
      // value: !this.value ? this.multiple ? [] : {} : this.value
    };
  },
  computed: {
    valData: {
      get() {
        return this.value ? this.value : this.multiple ? [] : {};
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    filteredMedia() {
      return this.multiple
        ? this.valData
        : this.valData.path
        ? [this.valData]
        : [];
    },
    fvValidate() {
      return this.uploading > 0 ? false : true;
    },

    tableFields() {
      const ret = [];
      ret.push("name");
      if (this.fields.indexOf("path") !== -1) {
        ret.push("path");
      }
      if (this.fields.indexOf("alt") !== -1) {
        ret.push("alt");
      }

      ret.push("action");
      ret.push("preview");
      return ret;
    },
  },
  methods: {
    deleteFile(index) {
      if (this.multiple) {
        const newValue = JSON.parse(JSON.stringify(this.valData));
        newValue.splice(index, 1);
        this.valData = newValue;
      } else {
        this.valData = {};
      }
    },
    fileChange(event) {
      if (!event.target.files.length) {
        return;
      }
      for (let i = 0; i < event.target.files.length; i++) {
        this.upload(event.target.files[i], this.onProgress);
      }
    },
    setDefault(index) {
      let newValue = JSON.parse(JSON.stringify(this.valData));
      if (this.multiple) {
        newValue = newValue.map((v) => {
          v.default = false;
          return v;
        });
        newValue[index].default = true;
      } else {
        newValue.default = true;
      }
      this.valData = newValue;
    },

    onProgress(percent) {
      this.uploadPercent = percent;
    },

    async upload(src, onProgress, filename = undefined) {
      this.uploading++;
      let type = "";
      if (src.type.indexOf("image") !== -1) type = "IMAGE";
      else if (src.type.indexOf("video") !== -1) type = "VIDEO";
      else if (src.type.indexOf("gif") !== -1) type = "GIF";
      else if (src.type.indexOf("mp3") !== -1) type = "MP3";
      else if (src.type.indexOf("AMR") !== -1) type = "AMR";
      else if (src.type.indexOf("mpeg") !== -1) type = "MPEG";

      if (this.type.indexOf(type) === -1) {
        const message = `<div>نوع فایل انتخابی باید <span class="mx-1" dir="ltr">${this.type.map(
          (val) => val
        )}</span> باشد</div>`;
        this.$errorAlert("نوع فایل انتخابی نادرست است", message);
        return this.avoidUpload();
      }

      const fd = new FormData();
      fd.append("file", src, filename);

      let config = {
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          // execute the callback
          if (onProgress) onProgress(percentCompleted);

          return percentCompleted;
        },
        cancelToken: new this.source((executor) => {
          this.axiosCancelExecutor = executor;
        }),
      };
      // https://dev.api.ighe3.com/v5/panel/book/image/upload/08
      const token = Vue.$cookies.get("accessToken");
      console.log("token", token);
      const http = await this.$http.init(true);
      axios
        .post(
          `${this.baseUrl}/panel/book/image/upload`,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
          // fd,
          // config
        )
        .then((res) => {
          this.progress = 100;
          let newValue = this.multiple
            ? JSON.parse(JSON.stringify(this.valData))
            : {};
          let newItem = res.data;
          newItem.path = res.data.relative_url || "";
          delete res.data.relative_url;
          if (this.fields.indexOf("type") !== -1) {
            newItem.type = type;
          }
          if (this.fields.indexOf("alt") !== -1) {
            newItem.alt = "";
          }
          if (this.fields.indexOf("default") !== -1) {
            newItem.default =
              (this.multiple && newValue.length === 0) || !this.multiple
                ? true
                : false;
          }
          if (this.multiple) newValue.push(newItem);
          else newValue = newItem;

          this.valData = newValue;
          setTimeout(() => {
            this.uploading--;
          }, 300);
        })
        .catch((err) => {
          console.log(err);
          this.$errorAlert("خطا", "متاسفانه مشکلی هنگام آپلود پیش آمد.");
          this.$refs.filepicker.value = "";
          setTimeout(() => {
            this.uploading--;
          }, 300);
          this.progress = 0;
          this.showImages = true;
          // this.$emit('errsor.vue', ((((err || {}).response || {}).data || {}) || 'upload'))
        });
    },
    avoidUpload() {
      setTimeout(() => {
        this.uploading--;
      }, 300);
      this.progress = 0;
      this.showImages = true;
    },
  },

  mounted() {
    setTimeout(() => {
      this.showImages = true;
    }, 1000);
  },
  created() {
    setTimeout(() => {
      this.source = this.$http.CancelToken();
    }, 1000);
  },
  // watch: {
  //   value: (newValue) => {
  //     this.value = !this.value ? this.multiple ? [] : {} : this.value
  //   }
  // }
};
</script>

<style lang="scss">
.app-image-uploader {
  padding: 0;
  direction: rtl;
  overflow: hidden;

  & > .fv-input-group > .fv-button {
    border-left: none;
    border-right: none;
    border-bottom: none;
  }

  &[invalid]:focus {
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.01), 0 0 1.5px 1px #d32f2f;
  }
}
</style>
